import {BlockNode} from 'substance'

class UnsupportedBlockNode extends BlockNode {}

UnsupportedBlockNode.type = 'unsupportedblocknode'

UnsupportedBlockNode.schema = {
    attributes: { type: 'object', default: {} },
    xmlContent: {type: 'string', default: ''},
    tagName: 'string',
    tagType: { type: 'string', optional: true}
}

export {UnsupportedBlockNode}
